import(/* webpackMode: "eager" */ "/vercel/path0/app/random/page.js");
